import { get, post } from "../request";

//根据订阅内容计算价格
export const price = (data) =>
  get(`/api/v1/subscription/price?plan=${data.plan}&seats=${data.seats}`);

// 退出登录获取到登录地址
export const loginOutAndCallbackUrl = (params) =>
  get(`/api/v1/user/extra/loginOutAndCallbackUrl`);

// 获取企业当前的订阅信息
export const status = (params) =>
  get(`/api/v1/subscription/status?organizationDid=${params}`);

// 获取企业当前的订阅用户
export const user = (params) => get(`/api/v1/subscription/user`, params);

//设置订阅用户的席位状态
export const Assignuser = (data) => post(`/api/v1/subscription/user`, data);

//企业更新当前订阅
export const subscription = (data) => post(`/api/v1/subscription`, data);